import gql from "graphql-tag";

export default gql`
  mutation VerifyUserEmail($id: ID!) {
    updateUser(id: $id, emailVerified: true) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/VerifyUserEmail.ts